<template>
  <div>
    <div class="h-title-con">
      <div class="h-title">
        <span class="title-tip"></span>
        <span class="title-text">组织管理</span>
      </div>
      <div class="h-button-warpper">
        <span class="orgBtn btn-font" @click="search()"><i class="iconfont icon-chaxun"></i><label>查询</label></span>
        <span class="orgBtn btn-font" @click="reset()"><i class="iconfont icon-shuaxin1"></i><label>重置</label></span>
        <span class="orgBtn btn-font" @click="goNewPage()"><i class="iconfont icon-tianjia2"></i><label>新增</label></span>
        <up-load :action="action" :fileType="file"></up-load>
      </div>
    </div>
    <div class="content-params" id="contentParams" :style="{height: isHidden}">
      <!-- 组织名称 -->
      <div class="params">
        <label class="custom_label">组织名称：</label>
        <span style="min-width:210px"><el-input placeholder="请输入组织名称" v-model="organizeSeach.organizeName"></el-input></span>
      </div>
      <!-- 组织编码 -->
      <div class="params">
        <label class="custom_label">组织编码：</label>
        <span style="min-width:210px"><el-input placeholder="请输入组织编码" v-model="organizeSeach.organizeCode"></el-input></span>
      </div>
      <!-- 负责人 -->
      <div class="params">
        <label class="custom_label">负责人：</label>
        <span style="min-width:210px"><el-input placeholder="请输入负责人" v-model="organizeSeach.staffName"></el-input></span>
      </div>
      <!-- 上级组织 -->
      <div class="params">
        <label class="custom_label">上级组织：</label>
        <span style="min-width:210px"><el-input placeholder="请输入上级组织" v-model="organizeSeach.upOrganizeName" ></el-input></span>
      </div>
      <!-- 状态 -->
      <div class="area-params">
          <label class="custom_label">状态：</label>
          <el-select class="area-select"  v-model="organizeSeach.status" style="min-width:210px" clearable collapse-tags placeholder="请选择所属组织">
            <i slot="prefix" class="el-input__icon el-icon-search"></i>
            <el-option
              v-for="item in statusData"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
      </div>
    </div>
    <div class="arrow_icon">
      <div class="border" @click="showAllParams">
        <i
          class="el-icon-arrow-down show-more-arrow"
          :class="[isHidden === 'auto'?'is-open':'']">
        </i>
      </div>
    </div>
  </div>
</template>
<script>
import upLoad from './upload.vue'
// import { methodPost } from '../../../api/request.js'
export default {
  name: 'customParams',
  components: { upLoad },
  props: {
    queryType: {
      type: String
    },
    organizeSeach: {
      type: Object
    }
  },
  data() {
    return {
      file: 'file',
      isHidden: '40px',
      screenHeight: 0,
      statusData: [
        {
          value: '',
          label: '全部'
        },
        {
          value: '1',
          label: '有效'
        },
        {
          value: '0',
          label: '无效'
        }
      ],
      // status: '', // 状态
      // organizeName: '',
      // organizeCode: '',
      // staffName: '',
      // upOrganizeName: '',
      action: '/sysOrganize/importSysOrganize'
    }
  },
  watch: {
    screenHeight: {
      handler(val) {
        if (!this.timer) {
          this.screenHeight = val
          this.timer = true
          setTimeout(() => {
            this.$eventBus.$emit('onresize', this.screenHeight)
            this.timer = false
          }, 400)
        }
      },
      deep: true,
      immediate: true
    }
  },
  created() {
  },
  mounted() {
    this.screenHeight = document.getElementById('contentParams').clientHeight
    window.onresize = () => {
      return (() => {
        if (document.getElementById('contentParams')) {
          this.screenHeight = document.getElementById('contentParams').clientHeight
        }
      })()
    }
  },
  methods: {
    /* 重置 */
    reset() {
      this.organizeSeach.status = ''
      this.organizeSeach.organizeName = ''
      this.organizeSeach.organizeCode = ''
      this.organizeSeach.staffName = ''
      this.organizeSeach.upOrganizeName = ''
      const obj = {
        status: this.organizeSeach.status,
        organizeName: this.organizeSeach.organizeName,
        organizeCode: this.organizeSeach.organizeCode,
        staffName: this.organizeSeach.staffName,
        upOrganizeName: this.organizeSeach.upOrganizeName
      }
      this.$emit('query', obj)
    },
    /* 是否展示全部params */
    showAllParams() {
      this.isHidden = this.isHidden === '40px' ? 'auto' : '40px'
      setTimeout(() => {
        this.screenHeight = document.getElementById('contentParams').clientHeight
      }, 50)
    },
    /* 查询 */
    search() {
      this.handlerChange('search')
    },
    /* 更改条件查询 */
    handlerChange(type) {
      const params = {
        status: this.organizeSeach.status, // 状态
        organizeName: this.organizeSeach.organizeName,
        organizeCode: this.organizeSeach.organizeCode,
        staffName: this.organizeSeach.staffName,
        upOrganizeName: this.organizeSeach.upOrganizeName
      }
      if (type === 'search') {
        this.$emit('query', params)
      }
    },
    /* 新增页面 */
    goNewPage() {
      this.$router.push('/organizationManagement/add')
    }

  }
}
</script>

<style type="text/scss" lang="scss" scoped>
.h-title-con{
  display:block;
  .h-title{
    float:left;
  }
  .h-button-warpper{
    padding-top:8px;
  }
}
.content-params {
  padding:5px 20px;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  max-width: 900px;
  overflow: hidden;
  .params {
    min-width:340px;
    margin: 5px 0;
    font-size: 0;
  }
  .area-params {
    width: 340px;
    margin: 5px 0;
    font-size: 0;
  }
  .custom_label {
    min-width: 80px;
    display:inline-block;
    font-size: 14px;
    font-weight:700;
    text-align: right;
    color:#606266;
    i {
      color: red;
      font-style: normal;
      vertical-align: middle;
    }
  }
}
.arrow_icon {
  position:relative;
  background:#fff;
  bottom: -5px;
  height:18px;
  border-radius:6px 6px 0 0;
  text-align: center;
  z-index:9;
  margin:0 20px;
  box-sizing: border-box;
  // border-top: 1px solid rgba(111, 107, 107, 0.14);
  .border {
    cursor: pointer;
    display: inline-block;
    width:40px;
    height:16px;
    background: #ebeef5;
    left: calc(50% - 20px);
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
    .show-more-arrow{
      position: relative;
      top: -1px;
      transition: 0.3s ease-in-out;
      &.is-open {
        transform: rotate(-180deg);
      }
    }
  }
}
.separator {
  border-top: 1px solid #c0c4cc;
  margin: 0 2px;
  width: 6px;
  height: 5px;
  display: inline-block;
}
</style>
<style>
.params .el-input{
    width:210px!important;
  }

</style>



// WEBPACK FOOTER //
// src/_app/wwka/src/views/userManagementList/customParams/indexTimesCompare.vue